import React, { createContext, useState, useEffect } from "react";

const API_BASE_URL = `https://${window.location.hostname.split('.')[0]}.pro102t1front.projectsworkspace.website/api`;

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [dashboardData, setDashboardData] = useState({});
  const [menuItems, setMenuItems] = useState([]);
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [logoutTimer, setLogoutTimer] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    // نحفظ وقت الدخول إذا لم يكن محفوظ
    if (token && !localStorage.getItem("loginTime")) {
      localStorage.setItem("loginTime", Date.now().toString());
    }

    // تحقق من صلاحية الجلسة
    checkSessionExpiration();

    // إعداد مؤقت داخلي يتم تجديده عند الحركة
    if (token) startLogoutTimer();

    const resetTimer = () => startLogoutTimer();
    document.addEventListener("mousemove", resetTimer);
    document.addEventListener("click", resetTimer);
    document.addEventListener("keydown", resetTimer);

    return () => {
      document.removeEventListener("mousemove", resetTimer);
      document.removeEventListener("click", resetTimer);
      document.removeEventListener("keydown", resetTimer);
    };
  }, []);

  // ⏰ التحقق من انتهاء الجلسة حتى لو الصفحة أعيد تحميلها
  const checkSessionExpiration = () => {
    const loginTime = localStorage.getItem("loginTime");
    if (!loginTime) return;

    const now = Date.now();
    const sessionDuration = now - parseInt(loginTime, 10);
    const maxSessionTime = 55 * 60 * 1000; // 55 دقيقة

    if (sessionDuration >= maxSessionTime) {
      console.log("🔒 Session expired while inactive");
      logout();
    }
  };

  // مؤقت داخلي للمراقبة أثناء النشاط
  const startLogoutTimer = () => {
    if (logoutTimer) clearTimeout(logoutTimer);

    const timer = setTimeout(() => {
      console.log("⏳ Session expired. Logging out...");
      logout();
    }, 55 * 60 * 1000);

    setLogoutTimer(timer);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("loginTime");

    if (logoutTimer) clearTimeout(logoutTimer);
    window.location.href = "/login";
  };

  // دوال جلب البيانات مثل fetchDashboardData و fetchMenu تبقى كما هي

  return (
    <AppContext.Provider value={{ dashboardData, menuItems, orders, customers, setMenuItems, setOrders }}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;
